import { getAreas } from "./getAreas";
import { getSupportedLanguagesAry } from "./translate";

export const getLangHref = (href, lang, area) => {
	if (!href) return undefined;

	// Check to see if this is a route to one of our pages
	if (href.startsWith('http') || href.startsWith('tel:')) {
		// Not one of our routes
		return href;
	}

	const { defaultLanguageCode } = getSupportedLanguagesAry();
	const { defaultAreaSlug } = getAreas();

	const root =
		lang !== defaultLanguageCode && area !== defaultAreaSlug
			? `/${lang}/${area}`
			: lang !== defaultLanguageCode
				? `/${lang}`
				: area !== defaultAreaSlug
					? `/${area}`
					: "";

	return `${root}${href}`;
};
